module.exports = __webpack_public_path__ + "static/media/trophy_1.b133f3ea.png";